import React from 'react';
import styled from 'styled-components';
import { colors } from '../theme/colors';
import { FONT_SANS } from '../constants';
import { useLanguage } from '../context/LanguageContext';

const Wrap = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 3px;
  border-radius: 999px;
  background: ${colors.secondary};
  border: 1px solid ${colors.secondaryBorder};
`;

const LangBtn = styled.button`
  font-family: ${FONT_SANS};
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  padding: 6px 10px;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
  background: ${({ $active }) => ($active ? colors.primary : 'transparent')};
  color: ${({ $active }) => ($active ? colors.primaryText : colors.inkSoft)};

  &:hover {
    color: ${({ $active }) => ($active ? colors.primaryText : colors.ink)};
  }
`;

function LanguageSwitcher({ compact = false }) {
  const { language, setLanguage, t } = useLanguage();

  return (
    <Wrap role="group" aria-label={t.lang.label}>
      <LangBtn
        type="button"
        $active={language === 'en'}
        aria-pressed={language === 'en'}
        onClick={() => setLanguage('en')}
      >
        {compact ? 'EN' : t.lang.en}
      </LangBtn>
      <LangBtn
        type="button"
        $active={language === 'zh'}
        aria-pressed={language === 'zh'}
        onClick={() => setLanguage('zh')}
      >
        {compact ? '中' : t.lang.zh}
      </LangBtn>
    </Wrap>
  );
}

export default LanguageSwitcher;
